import {Injectable} from '@angular/core';
import {SysConfigService} from './sys-config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UserPrivilegeDTO} from '../dto/user-privilege.model';
import {Observable} from 'rxjs/index';
import {OperationPrivilageModel} from '../dto/operation-privilage-model';
import {PageDTO} from '../dto/page.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class UserPrivilegeService {
  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });


  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  /** Save User Privilege Details**/
  saveUserPrivilege(userPrivilegeDTO: UserPrivilegeDTO[]) {
    return this.httpClient.post(this.BASE_URL + 'user-privilage/save' , userPrivilegeDTO,{headers: this.headers});
  }

  /** Get All User Priviledges **/
  getAllUserPriviledges(){
    return this.httpClient.get(this.BASE_URL + 'user-privilage' + "/all")
  }

  /** Get All User Privileges By User Role **/
  getUserPrivilegesByUserRole(userRole: string) {
    return this.httpClient.get(this.BASE_URL + 'user-privilage/getByUserRole/'+userRole);
  }

  /** Get User Privileges By UserRole **/
  getByUser(userName: string): Observable<PageDTO[]> {
    return this.httpClient.get<PageDTO[]>(this.BASE_URL + 'user-privilage/get/' + userName);
  }
}
